import React from "react";

import { AppError, ErrorResistantContent } from "ui/components";

export interface IErrorHandlerProps {
  layout?: React.ComponentType<any>;
}

export const ErrorHandler: React.FC<IErrorHandlerProps> = ({ layout, children }) => {
  return (
    <ErrorResistantContent layout={layout} fallbackComponentFactory={() => <AppError />}>
      {children}
    </ErrorResistantContent>
  );
};
